<template>
    <div class="comment_title">
        <p>성매매 없는 세상을 위한</p>
        <p>당신의 한마디를 남겨주세요</p>
    </div>
    <div class="comment_list_wrap">
        <template v-if="state.isMobile">
            <TextEffect :list="state.commentList" :is-vertical="true" />
        </template>
        <template v-else>
            <TextEffect :list="firstList" />
            <TextEffect :list="secondList" :isReverse="true" />
        </template>
    </div>
    <div class="my_comment_wrap">
        <label for="my_comment">
            <textarea name="my_comment" id="my_comment" minlength="10" maxlength="90" v-model="state.myComment"></textarea>
            <p class="custom_placeholder" v-if="!state.myComment">
                나의 한마디를 남겨주세요
                <br />
                (최소 10자, 최대 90자)
            </p>
        </label>
    </div>
    <div class="btns">
        <button id="prev" @click="prev">이전</button>
        <button id="next" @click="next">다음</button>
    </div>

    <ModalDefault :type="-1" v-if="modal.isShow" :title="modal.title" :content="modal.content" @close="modal.isShow = false"></ModalDefault>
</template>

<script lang="ts">
    import { onMounted, ModalDefault, reactive, apiService, CommonUtils, useRoute, ref, computed } from "@/BaseComponent";
    import TextEffect from "@/components/textEffect.vue";

    export default {
        props: {
            value: String,
        },
        emits: ["next", "prev"],
        components: { TextEffect, ModalDefault },
        setup(props: any, { emit }: any) {
            const route = useRoute();
            const state = reactive({
                isMobile: false,
                commentList: [] as string[],
                myComment: "" as string,
            });
            const modal = reactive({
                isShow: false,
                title: "",
                content: "",
            });
            const firstList = computed(() => state.commentList.slice(0, Math.ceil(state.commentList.length / 2)));
            const secondList = computed(() => state.commentList.slice(Math.ceil(state.commentList.length / 2)));

            onMounted(() => {
                if (props.value) state.myComment = props.value;
                if (route.params.id) getCommentList();
            });

            const prev = () => {
                emit("prev", state.myComment);
            };

            const next = () => {
                if (!state.myComment) {
                    modal.isShow = true;
                    modal.title = "알림";
                    modal.content = "나의 한마디를 입력해주세요.";
                } else if (state.myComment.length < 10 || state.myComment.length > 90) {
                    modal.isShow = true;
                    modal.title = "알림";
                    modal.content = "최소 10글자, 최대 90자 이하로 작성해주세요.";
                } else {
                    emit("next", state.myComment);
                }
            };

            const getCommentList = async () => {
                const res = await apiService.campainEvent.commentList(Number(route.params.id));
                if (res.returnCode === 0) {
                    state.commentList = res.list;
                } else {
                    state.commentList = [];
                }
            };

            onMounted(() => {
                state.isMobile = CommonUtils.checkIsMobile(700);
                window.addEventListener("resize", () => {
                    state.isMobile = CommonUtils.checkIsMobile(700);
                });
            });

            return {
                state,
                modal,
                prev,
                next,
                firstList,
                secondList,
            };
        },
    };
</script>

<style scoped></style>
